import api from "../api";
import {subscribeToChannel, unsubscribeToChannel} from "../services/pusher";
import dates from "../services/dates";

const state = {
  selectedDate: null,
  tasks: [],
};

const getters = {
  tasks(state) {
    let tasks = [...state.tasks]
    if (state.selectedDate === null) {
      return tasks.filter(task => dates.isInPast(task.due_at))
        .sort((a, b) => new Date(a.due_at) - new Date(b.due_at))
    }

    return tasks.filter(task => dates.isDateEqual(task.due_at, state.selectedDate))
      .sort((a, b) => new Date(a.due_at) - new Date(b.due_at))
  },
};

const mutations = {
  setup(state, data) {
    state.tasks = data.tasks
  },
  updateSelectedDate(state, date) {
    state.selectedDate = date
  },
  teardown(state) {
    state.selectedDate = null
    state.tasks = []
  },
};

const actions = {
  setup({commit, state, rootState, getters}, selectedDate) {
    subscribeToChannel("dashboardContacting", rootState.activeUser.id)

    return api.clientStore.initDashboardContacting(rootState.activeUser.id, selectedDate).then(response => {
      commit("updateSelectedDate", selectedDate)
      commit('setup', response.data);
    })
  },
  tearDown({commit, state, rootState, getters}) {
    unsubscribeToChannel("dashboardContacting", rootState.activeUser.id)
    commit('teardown')
  },
};

const DashboardContactingStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default DashboardContactingStore;
